import React, { useRef, useState, MouseEvent, useEffect } from "react";

interface DraggableScrollContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const DraggableScrollContainer: React.FC<DraggableScrollContainerProps> = ({
  children,
  className,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startY, setStartY] = useState<number>(0);
  const [scrollTop, setScrollTop] = useState<number>(0);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, []);

  const handleMouseDown = (event: MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) return;
    setIsDragging(true);
    setStartY(event.clientY);
    setScrollTop(containerRef.current.scrollTop);
  };

  const handleMouseMove = (event: MouseEvent<HTMLDivElement>) => {
    if (!isDragging || !containerRef.current) return;
    const dy = event.clientY - startY;
    containerRef.current.scrollTop = scrollTop - dy;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <div
      ref={containerRef}
      className={`${className} relative no-scrollbar select-none`}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}>
      {children}
    </div>
  );
};
